import { Field } from 'formik';
import FormikTextInput from '@/components/core/formik/FormikTextInput';
import styled from 'styled-components';
import Typography from '@/components/core/Typography/Typography';
import { FlexCol3XS } from '@/components/Flex';

const LabelWithButtonRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export function TextInputWithButton({ name, label = '', button, withIncreasedHorizontalPadding = false, ...props }) {
    return (
        <Field name={name}>
            {({ field, form }) => (
                <FlexCol3XS>
                    <LabelWithButtonRow>
                        {label &&
                            <label htmlFor={name}>
                                <Typography variant='uiType' size='xs' modifier='R'>{label}</Typography>
                            </label>}
                        {button}
                    </LabelWithButtonRow>
                    <FormikTextInput
                      field={field}
                      form={form}
                      {...props}
                      withIncreasedHorizontalPadding={withIncreasedHorizontalPadding}
                    />
                </FlexCol3XS>
            )}
        </Field>
    );
}
